import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getPaymentMode = () => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/paymentMode',
    headers: getHeaders(),
  });
};

export const getViewPaymentMode = (brandId) => {
  return axios({
    method: "get",
    url: STORE_BASE_URL + "/store/api/secure/v1/paymentMode/" + brandId, // for android use
    headers: getHeaders(),
  });
};


export const getAllPaymentModeByBrandId = (brandId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v2/paymentMode/' + brandId,
    headers: getHeaders(),
  });
};

export const getViewPaymentModeV2 = (brandId) => {
  return axios({
    method: "get",
    url: STORE_BASE_URL + "/store/api/secure/v3/paymentMode/" + brandId, // for android use
    headers: getHeaders(),
  });
};

export const postPaymentMode = (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/secure/v1/paymentMode", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postCustomerTransaction = async (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/secure/v1/customer-transaction", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postCallbackPaymentLink = async (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/external/v1/icici-transaction/callback-payment-link", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postCustomerTransactionStatusCheck = async (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/secure/v1/customer-transaction-status-check", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};